import React, { Component } from 'react';
import Formulario from './DescuentoHoraForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class DescuentoHora extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, listarColaborador, leer,
        limpiarDatos, leerPeriodoD } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        getModulo(modulo[5],modulo[4]);
        listarColaborador();
        limpiarDatos();
        leerPeriodoD(modulo[5], modulo[7]);
    }
    
    render(){
        const { loader, modulo, emp, registroDescuento,
            datosColaborador, cargo, lectura, modificarDescuento,
            sueldo, bonificacion, frecuencia, periodoD } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    emp = {emp}
                    registroDescuento = {registroDescuento}
                    cargo = {cargo}
                    datosColaborador = {datosColaborador}
                    lectura = {lectura}
                    modificarDescuento = {modificarDescuento}
                    sueldo = {sueldo}
                    bonificacion = {bonificacion}
                    frecuencia = {frecuencia}
                    periodo={periodoD}
                />
            </LoadMask>
        );
    }
}

export default DescuentoHora;